import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loader from "../Loader";
import ReactHtmlParser from "react-html-parser";
import MultiSelect from "@khanacademy/react-multi-select";
import firebase from "firebase";

class GSTR_2_TransactionWise extends Component {
  constructor(props) {
    super(props);
    const today = new Date().toISOString().split("T")[0];
    const lastWeek = props.addDays(-7).toISOString().split("T")[0];

    this.state = {
      transactions: [],
      stores: [],
      storeList: [{ key: props.user.store.key }],
      searchTransactionFromDate: lastWeek,
      searchTransactionToDate: today,
      loading: false,
      finalTable: null,
      selectedStores: [props.user.store.key],
    };

    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onClearSearch = this.onClearSearch.bind(this);
    this.onExportClick = this.onExportClick.bind(this);
  }

  async componentDidMount() {
    try {
      const stores = await this.props.getUserStores(
        this.props.user.user.RegistrationID,
        ""
      );
      const storeList = stores.map((store) => ({
        value: store.key,
        label: store.StoreName,
      }));

      this.setState({ stores: storeList }, () => {
        this.loadGSTR2Data(
          this.state.searchTransactionToDate,
          this.state.searchTransactionFromDate,
          this.state.storeList
        );
      });
    } catch (error) {
      console.error("Error loading stores:", error);
    }
  }

  async loadGSTR2Data(toDate, fromDate, storeList) {
    this.setState({ loading: true });

    try {
      const stores = storeList.map((store) => store.key);
      const fromTimestamp = new Date(fromDate).getTime();
      const toTimestamp = new Date(toDate).getTime() + 86399999; // Include full day (23:59:59.999)

      const searchParameters = {
        size: 10000,
        query: {
          bool: {
            must: [
              {
                range: {
                  TransactionDate: {
                    gte: fromTimestamp,
                    lte: toTimestamp,
                  },
                },
              },
              {
                terms: {
                  "Store.key.keyword": stores,
                },
              },
            ],
            should: [
              {
                match: {
                  "TransactionType.TransactionType": "Entry",
                },
              },
              {
                match: {
                  "TransactionType.TransactionType": "Return",
                },
              },
            ],
            minimum_should_match: 1,
          },
        },
      };
      console.log(JSON.stringify(searchParameters));
      const result = await firebase.functions().httpsCallable("getInventory")({
        text: searchParameters,
      });
      const inventory = result.data.text.hits.hits.map((data) => ({
        key: data._id,
        ...data._source,
      }));

      const gstr2Data = this.processGSTR2Data(inventory);
      const finalTable = this.generateGSTR2Table(gstr2Data);

      this.setState({
        transactions: gstr2Data,
        finalTable,
        loading: false,
      });
    } catch (error) {
      console.error("Error loading GSTR-2 data:", error);
      this.setState({ loading: false });
    }
  }

processGSTR2Data(inventory) {
  return inventory.map((source) => {
    const gstin = source.Vendor.CustomField1 || "";
    const invoiceNo = source.TransactionNo;
    const invoiceDate = new Date(Number(source.TransactionDate));
    const invoiceValue = source.BillAmount;

    let taxableValue = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    let cess = 0;
    console.log(source.TransactionType.TransactionType)
    const isReturn = (source.TransactionType.TransactionType || "").toLowerCase().includes("return")

    const vendorName = `${source.Vendor.VendorFirstName || ""} ${
      source.Vendor.VendorLastName || ""
    }`.trim();

    if (source.TaxSummaryList) {
      source.TaxSummaryList.forEach((taxItem) => {
        taxableValue += taxItem.TaxableAmount || 0;

        if (taxItem.TaxComponentAmount) {
          taxItem.TaxComponentAmount.forEach((taxComponent) => {
            const taxType = taxComponent.TaxType.toLowerCase() || "";
            const amount = taxComponent.TaxAmount || 0;

            switch (taxType) {
              case "cgst":
                cgst += amount;
                break;
              case "sgst":
                sgst += amount;
                break;
              case "igst":
                igst += amount;
                break;
              case "cess":
                cess += amount;
                break;
              default:
                break;
            }
          });
        }
      });
    }

    // If return, make all values negative
    const multiplier = isReturn ? -1 : 1;
    console.log(multiplier , invoiceNo)
    return {
      GSTIN: gstin,
      "Invoice No": invoiceNo,
      "Invoice Date": invoiceDate.toLocaleDateString(),
      "Invoice Value": (invoiceValue).toFixed(2),
      "Taxable Value": (taxableValue).toFixed(2),
      "Vendor Name": vendorName,
      CGST: (cgst * multiplier).toFixed(2),
      SGST: (sgst * multiplier).toFixed(2),
      IGST: (igst * multiplier).toFixed(2),
      CESS: (cess * multiplier).toFixed(2),
    };
  });
}


  generateGSTR2Table(data) {
    if (!data || data.length === 0) {
      return "<div class='alert alert-info'>No GSTR-2 transactions found for the selected criteria</div>";
    }

    const columns = Object.keys(data[0]);

    let html = `
    <table class='table table-bordered table-striped'>
      <thead class='thead-dark'>
        <tr>
          ${columns.map((col) => `<th>${col}</th>`).join("")}
        </tr>
      </thead>
      <tbody>
  `;

    data.forEach((item) => {
      html += "<tr>";
      columns.forEach((col) => {
        const align = [
          "Invoice Value",
          "Taxable Value",
          "CGST",
          "SGST",
          "IGST",
          "CESS",
        ].includes(col)
          ? "style='text-align:right'"
          : "";
        html += `<td ${align}>${item[col]}</td>`;
      });
      html += "</tr>";
    });

    html += "</tbody></table>";
    return html;
  }
  onSearchClick() {
    this.loadGSTR2Data(
      this.state.searchTransactionToDate,
      this.state.searchTransactionFromDate,
      this.state.storeList
    );
  }

  onClearSearch() {
    const lastWeek = this.props.addDays(-7).toISOString().split("T")[0];
    const today = new Date().toISOString().split("T")[0];

    this.setState(
      {
        searchTransactionToDate: today,
        searchTransactionFromDate: lastWeek,
        storeList: [{ key: this.props.user.store.key }],
        selectedStores: [this.props.user.store.key],
      },
      () => {
        this.loadGSTR2Data(today, lastWeek, this.state.storeList);
      }
    );
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.onSearchClick();
    }
  }

  async onExportClick() {
    const { transactions } = this.state;
    if (!transactions || transactions.length === 0) {
      alert("No data to export");
      return;
    }

    const csvContent = [
      Object.keys(transactions[0]).join(","),
      ...transactions.map((item) => Object.values(item).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `GSTR2_Transactions_${new Date().toISOString().split("T")[0]}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const {
      searchTransactionFromDate,
      searchTransactionToDate,
      stores,
      selectedStores,
      loading,
      finalTable,
    } = this.state;

    return (
      <div className="content-wrapper">
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box box-primary">
                <div className="box-header with-border">
                  <h3 className="box-title">GSTR-2 Transaction Wise Report</h3>
                  <div className="box-tools pull-right">
                    <button
                      className="btn btn-box-tool"
                      onClick={() =>
                        this.props.history.push("/home/reports/allreport")
                      }
                    >
                      <i className="fa fa-arrow-left"></i> Back
                    </button>
                  </div>
                </div>

                <div className="box-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Store Name</label>
                        <MultiSelect
                          selectAllLabel="All Stores"
                          options={stores}
                          selected={selectedStores}
                          onSelectedChanged={(selected) => {
                            const storeList =
                              selected.length > 0
                                ? selected.map((key) => ({ key }))
                                : [{ key: this.props.user.store.key }];

                            this.setState({
                              storeList,
                              selectedStores:
                                selected.length > 0
                                  ? selected
                                  : [this.props.user.store.key],
                            });
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>From Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={searchTransactionFromDate}
                          onChange={(e) =>
                            this.setState({
                              searchTransactionFromDate: e.target.value,
                            })
                          }
                          onKeyPress={this.handleKeyPress}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>To Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={searchTransactionToDate}
                          onChange={(e) =>
                            this.setState({
                              searchTransactionToDate: e.target.value,
                            })
                          }
                          onKeyPress={this.handleKeyPress}
                        />
                      </div>
                    </div>

                    <div
                      className="col-md-5 text-right"
                      style={{ paddingTop: "25px" }}
                    >
                      <button
                        className="btn btn-default"
                        onClick={this.onClearSearch}
                        style={{ marginRight: "5px" }}
                      >
                        Clear
                      </button>
                      <button
                        className="btn btn-primary"
                        disabled={
                          !searchTransactionFromDate || !searchTransactionToDate
                        }
                        onClick={this.onSearchClick}
                        style={{ marginRight: "5px" }}
                      >
                        Search
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={this.onExportClick}
                      >
                        <i className="fa fa-download"></i> Export
                      </button>
                    </div>
                  </div>

                  <div className="row" style={{ marginTop: "20px" }}>
                    <div className="col-md-12">
                      {loading && <Loader show={true} />}
                      {!loading && finalTable && ReactHtmlParser(finalTable)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(GSTR_2_TransactionWise);
